/** Mirrors apps/web/src/time.ts: slots are 15-minute UTC windows named YYYYMMDDHHmm. */
export const SLOT = 900;

export function slotStart(id: string): number {
  return Date.UTC(+id.slice(0, 4), +id.slice(4, 6) - 1, +id.slice(6, 8), +id.slice(8, 10), +id.slice(10, 12)) / 1000;
}

export function slotId(sec: number): string {
  return new Date((sec - (sec % SLOT)) * 1000).toISOString().replace(/[-:T]/g, "").slice(0, 12);
}

const dmy = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/London", day: "2-digit", month: "2-digit", year: "numeric" });
const hm = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/London", hour: "2-digit", minute: "2-digit", hourCycle: "h23" });

/** "2026-09-23" → "23/09/2026" */
export const ukDate = (iso: string | null | undefined): string =>
  iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : "—";
export const ukDateOf = (sec: number): string => dmy.format(new Date(sec * 1000));
export const ukTime = (sec: number): string => hm.format(new Date(sec * 1000));
